module.exports = __webpack_public_path__ + "img/frame_characters_2.133264dc.png";